import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditStudentLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CreateNewStudents' */ './components/EditStudent'
		)
);

export default (store) => {
	return {
		path: 'students-setup/:campusId?/edit-student/:id',
		element: <AsyncLoading component={<EditStudentLazy />} />,
	};
};
